import { Crown, UserRound, UserPlus, ArrowRight } from "lucide-react";
import Reveal from "./Reveal";
import { scrollToId } from "@/lib/lenis";

const MEMBERS = [
  {
    name: "Petr Lehnert",
    role: "Zakladatel aliance • Všestranný řemeslník",
    bio: "Od první skici až po předání klíčů. Od řízení celého projektu po detailní řemeslnou práci. Jako garant nesu plnou odpovědnost za celou vaši zakázku.",
    main: [
      "Kompletní suchá výstavba (sádrokartony)",
      "Zateplování fasád certifikovanými systémy ETICS",
    ],
    extra: [
      "Realizace podlah (lití, vinyl, dřevo)",
      "Betonářské práce a základové desky",
      "Omítky, štuky a sádrové stěrky",
      "Obkladačské práce",
      "Svařování plastových rozvodů vody (PPR)",
      "Základní elektroinstalace",
    ],
    photo: "/assets/gallery/founder-1.webp",
    founder: true,
  },
  {
    name: "Michal",
    role: "Mistr obkladač",
    bio: "25 let úzké specializace z něj dělá absolutního mistra v oboru. To, co zvládne v neuvěřitelné rychlosti, má vždy milimetrovou preciznost a dokonalý detail. Je expert na naprosto přesné rozpočítání a rozvržení spárořezu před samotnou pokládkou.",
    main: [
      "Kompletní realizace koupelen",
      "Velkoformátové dlažby",
      "Náročné komerční fit-outy prodejen (Sinsay, Nanu-Nana)",
    ],
    monogram: "M",
    note: "Fotky realizací doplníme",
  },
];

export default function Members() {
  return (
    <section id="remeslnici" data-testid="members-section" className="py-24 lg:py-32 bg-ink">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
        <Reveal>
          <p className="text-xs font-mono tracking-[0.3em] uppercase text-gold/70 mb-4">
            Členové aliance
          </p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-zinc-100 leading-tight max-w-3xl">
            Konkrétní lidé, <span className="gold-text">konkrétní řemeslo</span>
          </h2>
          <p className="mt-5 max-w-2xl text-zinc-400 leading-relaxed">
            Žádní anonymní dělníci od personální agentury. Každý člen RESTART PRO je živnostník
            s vlastním jménem, praxí a fotkami své práce. Aliance roste pomalu a schválně —
            nový člen musí nejdřív dokázat kvalitu na společné stavbě.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-5">
          {MEMBERS.map((m, i) => (
            <Reveal key={m.name} delay={i * 0.08} className="h-full">
              <div
                data-testid={`member-card-${i}`}
                className={`h-full rounded-xl border p-7 transition-colors duration-500 ${
                  m.founder
                    ? "bg-card2 border-gold/40 gold-glow"
                    : "bg-card2 border-white/5 hover:border-gold/30"
                }`}
              >
                <div className="flex items-center gap-4">
                  {m.photo ? (
                    <img
                      src={m.photo}
                      alt={m.name}
                      className="w-16 h-16 rounded-full object-cover border-2 border-gold/50"
                      data-testid={`member-photo-${i}`}
                    />
                  ) : (
                    <span className="w-16 h-16 rounded-full bg-gold/10 border-2 border-gold/50 flex items-center justify-center text-gold font-bold text-2xl font-sans">
                      {m.monogram}
                    </span>
                  )}
                  <div>
                    <p className="text-zinc-100 font-semibold text-lg flex items-center gap-2">
                      {m.name}
                      {m.founder && <Crown size={15} className="text-gold" />}
                    </p>
                    <p className="text-gold/80 text-xs font-mono tracking-wide mt-0.5">{m.role}</p>
                  </div>
                </div>
                <p className="mt-5 text-sm text-zinc-400 leading-relaxed">{m.bio}</p>
                <div className="mt-6">
                  <p className="text-[10px] font-mono tracking-[0.25em] uppercase text-gold/80">
                    Hlavní specializace
                  </p>
                  <div className="mt-2.5 flex flex-wrap gap-2">
                    {m.main.map((t) => (
                      <span
                        key={t}
                        className="text-[11px] font-semibold bg-gold/10 border border-gold/40 rounded-full px-3 py-1 text-gold"
                      >
                        {t}
                      </span>
                    ))}
                  </div>
                </div>
                {m.extra && (
                  <div className="mt-5">
                    <p className="text-[10px] font-mono tracking-[0.25em] uppercase text-zinc-500">
                      Dále perfektně zvládám
                    </p>
                    <div className="mt-2.5 flex flex-wrap gap-2">
                      {m.extra.map((t) => (
                        <span
                          key={t}
                          className="text-[11px] border border-white/10 rounded-full px-3 py-1 text-zinc-400"
                        >
                          {t}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
                {m.note && (
                  <p className="mt-4 text-[11px] text-zinc-600 italic">{m.note}</p>
                )}
              </div>
            </Reveal>
          ))}

          <Reveal delay={0.16} className="h-full">
            <div
              data-testid="member-card-join"
              className="h-full rounded-xl border border-dashed border-gold/25 bg-ink/40 p-7 flex flex-col justify-center"
            >
              <span className="w-16 h-16 rounded-full bg-gold/5 border-2 border-dashed border-gold/40 flex items-center justify-center text-gold">
                <UserPlus size={24} />
              </span>
              <p className="mt-5 text-zinc-100 font-semibold text-lg">Další řemeslníci</p>
              <p className="text-gold/80 text-xs font-mono tracking-wide mt-0.5">
                elektrikář · sádrokartonář · instalatér
              </p>
              <p className="mt-5 text-sm text-zinc-400 leading-relaxed">
                Profily dalších prověřených členů právě připravujeme. Aliance není o množství —
                je o lidech, za které ručíme vlastním jménem.
              </p>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.2}>
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-4 border border-gold/20 bg-gold/5 rounded-xl px-6 py-5">
            <p className="text-sm text-zinc-300 flex items-center gap-3">
              <UserRound size={17} className="text-gold shrink-0" />
              Ceny a dostupnost termínů zjistíte poptávkou — komunikace vždy přes Petra,
              zakladatele aliance.
            </p>
            <button
              onClick={() => scrollToId("kontakt")}
              data-testid="members-cta"
              className="inline-flex items-center gap-2 bg-gold text-black font-semibold rounded-full px-6 py-2.5 text-sm hover:bg-gold-light transition-colors shrink-0"
            >
              Nezávazná poptávka <ArrowRight size={15} />
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
